import React, { createContext, useEffect, useState } from 'react';
import { CustomerTagPricing } from '../clients/customer-api/customer/customer-customer';
import { useCustomerAPI } from '../clients/customer-api/customer-api-client';
import { ToastContainer } from 'react-toastify';

export interface CustomerContext {
  id: number;
  name: string;
  email: string;
  tagPricing?: CustomerTagPricing;
  defaultTaxCodeId?: string;
  paymentBan: boolean;
  chargeTax: boolean;
}

export const CustomerContext = createContext<CustomerContext | undefined>(undefined);

export const CustomerContextProvider = ({ children }: React.PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [customerContext, setCustomerContext] = useState<CustomerContext>();
  const { userContext } = useCustomerAPI();

  const getCustomerContextFromAPI = () => {
    userContext().then((context) => {
      setCustomerContext(context);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getCustomerContextFromAPI();
  }, []);

  return !isLoading ? (
    <CustomerContext.Provider value={customerContext}>
      <ToastContainer className="top-[113px] z-[10001]" />
      {children}
    </CustomerContext.Provider>
  ) : null;
};
